import { authHelper } from './auth';
import { registerAuthentication } from './authentication-owner';

registerAuthentication(authHelper(), 'legacy');
